export default {
  filterData: [],
  vendorCategories: [],
  vendorsOnCategory: [],
};
